const toTitleCase = (input: string | null): string => {
	if (!input) return "";
	return input.toLowerCase().replace(/(?:^|\s|\/|\-)\w/g, match => {
		return match.toUpperCase();
	});
};

export default toTitleCase;
